var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMenuOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 56 56"
    },
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0{fill:#87c7f7}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    transform: "translate(-343 -14)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    cx: 382,
    cy: 42,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    cx: 382,
    cy: 31,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    cx: 382,
    cy: 53,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    cx: 371,
    cy: 42,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    cx: 371,
    cy: 31,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    cx: 371,
    cy: 53,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    cx: 360,
    cy: 42,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    cx: 360,
    cy: 31,
    r: 3.5,
    className: "st0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    cx: 360,
    cy: 53,
    r: 3.5,
    className: "st0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_849",
    d: "M0 54.7h56V56H0z",
    className: "st0 animate-line"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuOn);
export default __webpack_public_path__ + "static/media/mobile-menu-on.f687121e3c5f0c806018ef1f4a70c1fd.svg";
export { ForwardRef as ReactComponent };